// app.module.ts
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

// PrimeNG Imports
import { StepsModule } from 'primeng/steps';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';

// Component Imports
import { PublicHeaderComponent } from './header/header.component';
import { PublicFooterComponent } from './footer/footer.component';
import { EmpresaComponent } from './pages/empresa/empresa.component';
import { CadastroEmpresaComponent } from './pages/empresa/cadastro/cadastro-empresa.component';
import { MessageService } from 'primeng/components/common/messageservice';
import { AnaliseComponent } from './pages/analise/analise.component';
import { SucessoComponent } from './pages/sucesso/sucesso.component';
import { LoginEmpresaComponent } from './pages/login/login-empresa.component';
import { LogarEmpresaComponent } from './pages/login/logar/logar.component';
import { RecuperarSenhaComponent } from './pages/login/recuperar-senha/recuperar-senha.component';
import { IndicacaoComponent } from './pages/indicacao/indicacao.component';
import { GerenciarIndicadoComponent } from './pages/indicacao/gerenciar-indicacao/gerenciar-indicacao.component';
import { EmpresaEditalComponent } from './pages/editais/empresa-edital-root.component';
import { ListarEditalComponent } from './pages/editais/listar/listar-edital.component';
import { AceiteEditalComponent } from './pages/editais/aceite/aceite-edital.component';

@NgModule({
  declarations: [
    PublicHeaderComponent,
    PublicFooterComponent,
    EmpresaComponent,
    CadastroEmpresaComponent,
    AnaliseComponent,
    SucessoComponent,
    LoginEmpresaComponent,
    LogarEmpresaComponent,
    RecuperarSenhaComponent,
    IndicacaoComponent,
    GerenciarIndicadoComponent,
    EmpresaEditalComponent,
    ListarEditalComponent,
    AceiteEditalComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    StepsModule,
    CardModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    InputMaskModule,
    MessageModule,
    MessagesModule,
    TableModule,
  ],
  providers: [ MessageService],
})
export class PublicModule { }



// WEBPACK FOOTER //
// ./src/app/components/_public-layout/public-layout.module.ts